module.exports = __webpack_public_path__ + "img/stu-logo-bg.5b552b27.png";